export { default } from "./bubbleTail";
